export default __webpack_public_path__ + "static/media/03.ef95c85d.jpg";